module.exports = __webpack_public_path__ + "static/media/smove.3d6d707c.gif";